export default [
    {
        path: '/negocios', component: () => import('./components/Page'), name: 'negocio.page', children: [
            {path: '', component: () => import('./components/Kanban'), name: 'negocio.kanban'},
            {path: 'funil/criar', component: () => import('./components/Funil'), name: 'funil.novo'},
        ]
    }
]
